import { render, staticRenderFns } from "./RTab.vue?vue&type=template&id=33ffad63&scoped=true"
import script from "./RTab.vue?vue&type=script&lang=js"
export * from "./RTab.vue?vue&type=script&lang=js"
import style0 from "./RTab.vue?vue&type=style&index=0&id=33ffad63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ffad63",
  null
  
)

export default component.exports